// @ts-nocheck
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { getListPath, getNominative } from '../../../common/utils'
import { colors } from '@lmc/common/constants'
import { isBrowser, isTablet } from 'react-device-detect'
import { ResponsiveText } from '../../../LEGACY/elemental'
import { Link } from 'react-router-dom'
import SidebarItem from '../SidebarItem/SidebarItem'
import SidebarFilter from '../SidebarFilter/SidebarFilter'
import { AccessRestriction } from '../AccessRestriction'
import { ButtonOLD } from '@lmc/ui-kit'
import Glyph from '../../../LEGACY/Glyph'
import { history } from '../../../store'
import { withRouter } from '../../../withRouter'

class Sidebar extends Component {
  state = {
    nameSearch: '',
  }

  handleSearchChange = (value) => {
    this.setState({
      nameSearch: value,
    })
  }

  matchesSearch = (item) => {
    const fullName = `${item.name.first} ${item.name.last}`
    return !!fullName.match(
      new RegExp(
        this.state.nameSearch.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'),
        'i'
      )
    )
  }

  renderHeader = () => {
    let { title } = this.props
    if (!title) {
      title =
        this.props.screenId === 'residents'
          ? getNominative(this.props.preferredPeopleNominative, 'Residents')
          : 'Team Members'
    }

    return (
      <div style={styles.header}>
        <span style={styles.title}>{title}</span>
      </div>
    )
  }

  renderItem = (item, index) => {
    const { screenId, router, placeholderPicture } = this.props

    let currentListPath = isDesktop
      ? getListPath(history.location.pathname, router.params)
      : 'profile'

    if (currentListPath === 'edit' || currentListPath === 'history') {
      currentListPath = 'profile'
    }
    return (
      <Link
        key={index}
        style={{ textDecoration: 'none', color: 'black' }}
        to={`/${screenId}/${item.id}/${currentListPath}`}
      >
        <SidebarItem
          placeholderPicture={placeholderPicture}
          itemData={item}
          isSelected={item.id === router.params.id}
        />
      </Link>
    )
  }

  render() {
    const {
      allFilters,
      hideCreateButton,
      filterId,
      items,
      screenId,
      onCreate,
      style,
      preferredPeopleNominative,
    } = this.props

    const searchResults = _.filter(items, this.matchesSearch)
    const buttonText =
      screenId === 'residents'
        ? getAddResidentButtonText(preferredPeopleNominative)
        : 'Invite a Team Member'
    const buttonGlyph = screenId === 'residents' ? 'plus' : 'mail'

    return (
      <div className="lmc-sidebar" style={{ ...style, ...styles.container }}>
        {this.renderHeader()}
        {allFilters && (
          <SidebarFilter
            allFilters={allFilters}
            filterId={filterId}
            onSearchChange={this.handleSearchChange}
          />
        )}
        {!hideCreateButton && (
          <AccessRestriction>
            <ButtonOLD
              type="primary"
              id="sidebar-add-button"
              icon={<Glyph name={buttonGlyph} />}
              onClick={onCreate}
              style={styles.button}
              buttonInnerStyle={styles.innerButton}
              dataTestId="add-button"
            >
              <ResponsiveText
                visibleSM={null}
                visibleMD="Add"
                visibleLG={buttonText}
              />
            </ButtonOLD>
          </AccessRestriction>
        )}
        {searchResults.length ? (
          <ul className="lmc-sidebar-list">
            {searchResults.map(this.renderItem)}
          </ul>
        ) : null}
        {!searchResults.length && items.length ? (
          <div style={styles.emptyText}>No matches</div>
        ) : null}
      </div>
    )
  }
}

const getAddResidentButtonText = (preferredPeopleNominative) => {
  if (
    preferredPeopleNominative !== 'Supported Person' &&
    preferredPeopleNominative !== 'Service Users (SU)'
  )
    return `Add a ${getNominative(preferredPeopleNominative, 'Resident')}`
  return 'Add'
}

const isDesktop = isBrowser || isTablet

const styles = {
  container: {
    backgroundColor: colors.white,
  },
  button: {
    borderRadius: 0,
    justifyContent: 'center',
  },
  innerButton: {
    width: '100%',
    justifyContent: 'center',
    borderRadius: 0,
  },
  header: {
    padding: '39px 0px 5px 15px',
    display: 'inline-block',
  },
  emptyText: {
    color: colors.darkgrey,
    fontSize: 20,
    fontWeight: 300,
    margin: '0 auto',
    paddingTop: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
  },
}

Sidebar.propTypes = {
  title: PropTypes.string,
  allFilters: PropTypes.object,
  filterId: PropTypes.string,
  hideCreateButton: PropTypes.bool,
  items: PropTypes.array.isRequired,
  screenId: PropTypes.string.isRequired,
  onCreate: PropTypes.func,
  style: PropTypes.object,
}

export const SidebarComponent = Sidebar

export default withRouter(Sidebar)
